import store from '../redux/store';
import Events from '../services/Analytics';

export type TaskEvents =
  | 'filter'
  | 'add'
  | 'save'
  | 'close'
  | 'download'
  | 'search'
  | 'searchAll';
export type ListFilters =
  | 'to-do'
  | 'completed'
  | 'new-hires'
  | 'all'
  | 'no-round'
  | 'recently-completed'
  | 'new-nurses'
  | 'new-to-hca-nurses'
  | 'new-to-dept-nurses'
  | 'expert'
  | 'competent'
  | 'developing'
  | 'search'
  | 'search-all'
  | 'table';
export type HistorySideNavFilters =
  | 'profile'
  | 'past-notes'
  | 'save-notes'
  | 'past-rounds'
  | 'past-issues'
  | 'past-feedback';
export type RoundEvents = 'start' | 'cancel' | 'complete';
export type ReportEvents =
  | 'calendar'
  | 'date-range'
  | 'filter'
  | 'info'
  | 'export'
  | 'download-pdf'
  | 'search'
  | 'compliance'
  | 'issue'
  | 'recognition'
  | 'stoplight';
export type HelpEvents = 'sharepoint' | 'health-stream' | 'hr-emp-rounding';
export type DelegateDropdownFilters = 'direct-report' | 'delegate' | '';

// Tasks actions
export function logAdHocClick(type: string, event: TaskEvents) {
  const { coid } = store.getState().AuthorizedUser.authorizedUser;

  const defaultModuleTypeOrg = {
    module: Events.AddNew.Module,
    eventType: 'action',
    org: {
      orgId: coid,
      orgLevel: 'Facility'
    }
  };
  switch (event) {
    case 'add':
      switch (type) {
        case 'Add Issue':
          return [
            {
              screen: Events.AddNew.Screen.AddNewIssue.Name,
              eventName:
                Events.AddNew.Screen.AddNewIssue.Events.Add_New_Issue_Click,
              ...defaultModuleTypeOrg
            }
          ];
        case 'Feedback':
          return [
            {
              screen: Events.AddNew.Screen.AddNewFeedback.Name,
              eventName:
                Events.AddNew.Screen.AddNewFeedback.Events
                  .Add_New_Feedback_Click,
              ...defaultModuleTypeOrg
            }
          ];
        case 'Add Stoplight':
          return [
            {
              screen: Events.AddNew.Screen.AddNewStoplight.Name,
              eventName:
                Events.AddNew.Screen.AddNewStoplight.Events
                  .Add_New_Stoplight_Click,
              ...defaultModuleTypeOrg
            }
          ];
        default:
          return [];
      }
    case 'save':
      switch (type) {
        case 'Add Issue':
          return [
            {
              screen: Events.AddNew.Screen.AddNewIssue.Name,
              eventName:
                Events.AddNew.Screen.AddNewIssue.Events.Save_Issue_Click,
              ...defaultModuleTypeOrg
            }
          ];
        case 'Feedback':
          return [
            {
              screen: Events.AddNew.Screen.AddNewFeedback.Name,
              eventName:
                Events.AddNew.Screen.AddNewFeedback.Events.Save_Feedback_Click,
              ...defaultModuleTypeOrg
            }
          ];
        case 'Add Stoplight':
          return [
            {
              screen: Events.AddNew.Screen.AddNewStoplight.Name,
              eventName:
                Events.AddNew.Screen.AddNewStoplight.Events
                  .Save_Stoplight_Click,
              ...defaultModuleTypeOrg
            }
          ];
        default:
          return [];
      }
    case 'close':
      switch (type) {
        case 'Add Issue':
          return [
            {
              screen: Events.AddNew.Screen.AddNewIssue.Name,
              eventName:
                Events.AddNew.Screen.AddNewIssue.Events.Close_Issue_Click,
              ...defaultModuleTypeOrg
            }
          ];
        case 'Feedback':
          return [
            {
              screen: Events.AddNew.Screen.AddNewFeedback.Name,
              eventName:
                Events.AddNew.Screen.AddNewFeedback.Events.Close_Feedback_Click,
              ...defaultModuleTypeOrg
            }
          ];
        case 'Add Stoplight':
          return [
            {
              screen: Events.AddNew.Screen.AddNewStoplight.Name,
              eventName:
                Events.AddNew.Screen.AddNewStoplight.Events
                  .Close_Stoplight_Click,
              ...defaultModuleTypeOrg
            }
          ];
        default:
          return [];
      }
    default:
      return [];
  }
}

export function logTaskClick(view: string, event: TaskEvents) {
  const { coid } = store.getState().AuthorizedUser.authorizedUser;
  const { userSection } = store.getState().UserReducer;

  const defaultTypeOrg = {
    eventType: 'action',
    org: {
      orgId: coid,
      orgLevel: 'Facility'
    }
  };
  switch (view) {
    case 'issues':
      return [
        userSection === 'employee'
          ? {
              module: Events.Employee.Module,
              screen: Events.Employee.Screen.Issues.Name,
              eventName:
                event === 'filter'
                  ? Events.Employee.Screen.Issues.Events.Filter_Click
                  : event === 'add'
                  ? Events.Employee.Screen.Issues.Events.Add_Issue_Click
                  : event === 'save'
                  ? Events.Employee.Screen.Issues.Events.Save_Issue_Click
                  : event === 'close'
                  ? Events.Employee.Screen.Issues.Events.Close_Issue_Click
                  : event === 'download'
                  ? Events.Employee.Screen.Issues.Events.Download_Click
                  : Events.Employee.Screen.Issues.Events.Search_Click,
              ...defaultTypeOrg
            }
          : {
              module: Events.Patient.Module,
              screen: Events.Patient.Screen.Issues.Name,
              eventName:
                event === 'filter'
                  ? Events.Patient.Screen.Issues.Events.Filter_Click
                  : event === 'add'
                  ? Events.Patient.Screen.Issues.Events.Add_Issue_Click
                  : event === 'save'
                  ? Events.Patient.Screen.Issues.Events.Save_Issue_Click
                  : event === 'close'
                  ? Events.Patient.Screen.Issues.Events.Close_Issue_Click
                  : event === 'download'
                  ? Events.Patient.Screen.Issues.Events.Download_Click
                  : Events.Patient.Screen.Issues.Events.Search_Click,
              ...defaultTypeOrg
            }
      ];
    case 'feedback':
      return [
        userSection === 'employee'
          ? {
              module: Events.Employee.Module,
              screen: Events.Employee.Screen.Feedback.Name,
              eventName:
                event === 'filter'
                  ? Events.Employee.Screen.Feedback.Events.Filter_Click
                  : event === 'add'
                  ? Events.Employee.Screen.Feedback.Events.Add_Feedback_Click
                  : event === 'save'
                  ? Events.Employee.Screen.Feedback.Events.Save_Feedback_Click
                  : event === 'close'
                  ? Events.Employee.Screen.Feedback.Events.Close_Feedback_Click
                  : event === 'download'
                  ? Events.Employee.Screen.Feedback.Events.Download_Click
                  : Events.Employee.Screen.Feedback.Events.Search_Click,
              ...defaultTypeOrg
            }
          : {
              module: Events.Patient.Module,
              screen: Events.Patient.Screen.Feedback.Name,
              eventName:
                event === 'filter'
                  ? Events.Patient.Screen.Feedback.Events.Filter_Click
                  : event === 'add'
                  ? Events.Patient.Screen.Feedback.Events.Add_Feedback_Click
                  : event === 'save'
                  ? Events.Patient.Screen.Feedback.Events.Save_Feedback_Click
                  : event === 'close'
                  ? Events.Patient.Screen.Feedback.Events.Close_Feedback_Click
                  : event === 'download'
                  ? Events.Patient.Screen.Feedback.Events.Download_Click
                  : Events.Patient.Screen.Feedback.Events.Search_Click,
              ...defaultTypeOrg
            }
      ];
    case 'stoplight':
      return [
        userSection === 'employee'
          ? {
              module: Events.Employee.Module,
              screen: Events.Employee.Screen.Stoplights.Name,
              eventName:
                event === 'filter'
                  ? Events.Employee.Screen.Stoplights.Events.Filter_Click
                  : event === 'add'
                  ? Events.Employee.Screen.Stoplights.Events.Add_Stoplight_Click
                  : event === 'save'
                  ? Events.Employee.Screen.Stoplights.Events
                      .Save_Stoplight_Click
                  : event === 'close'
                  ? Events.Employee.Screen.Stoplights.Events
                      .Close_Stoplight_Click
                  : event === 'download'
                  ? Events.Employee.Screen.Stoplights.Events.Download_Click
                  : Events.Employee.Screen.Stoplights.Events.Search_Click,
              ...defaultTypeOrg
            }
          : {
              module: Events.Patient.Module,
              screen: Events.Patient.Screen.Stoplights.Name,
              eventName:
                event === 'filter'
                  ? Events.Patient.Screen.Stoplights.Events.Filter_Click
                  : event === 'add'
                  ? Events.Patient.Screen.Stoplights.Events.Add_Stoplight_Click
                  : event === 'save'
                  ? Events.Patient.Screen.Stoplights.Events.Save_Stoplight_Click
                  : event === 'close'
                  ? Events.Patient.Screen.Stoplights.Events
                      .Close_Stoplight_Click
                  : event === 'download'
                  ? Events.Patient.Screen.Stoplights.Events.Download_Click
                  : Events.Patient.Screen.Stoplights.Events.Search_Click,
              ...defaultTypeOrg
            }
      ];
    default:
      console.log('No task view for event');
      return [];
  }
}

// Table views
export const logTableStart = (lastPath: string | null) => {
  const { coid } = store.getState().AuthorizedUser.authorizedUser;

  const defaultNameTypeOrg = {
    eventName: null,
    eventType: 'start',
    org: {
      orgId: coid,
      orgLevel: 'Facility'
    }
  };
  switch (lastPath) {
    case '/patients/census':
      return [
        {
          module: Events.Patient.Module,
          screen: Events.Patient.Screen.Census.Name,
          ...defaultNameTypeOrg
        }
      ];
    case '/patients/issues':
      return [
        {
          module: Events.Patient.Module,
          screen: Events.Patient.Screen.Issues.Name,
          ...defaultNameTypeOrg
        }
      ];
    case '/patients/feedback':
      return [
        {
          module: Events.Patient.Module,
          screen: Events.Patient.Screen.Feedback.Name,
          ...defaultNameTypeOrg
        }
      ];
    case '/patients/stoplight':
      return [
        {
          module: Events.Patient.Module,
          screen: Events.Patient.Screen.Stoplights.Name,
          ...defaultNameTypeOrg
        }
      ];
    case '/employees/list/user':
      return [
        {
          module: Events.Employee.Module,
          screen: Events.Employee.Screen.DirectReports.Name,
          ...defaultNameTypeOrg
        }
      ];
    case '/employees/list/delegate':
      return [
        {
          module: Events.Employee.Module,
          screen: Events.Employee.Screen.Delegate.Name,
          ...defaultNameTypeOrg
        }
      ];
    case '/employees/list/adhoc':
      return [
        {
          module: Events.Employee.Module,
          screen: Events.Employee.Screen.Adhoc.Name,
          ...defaultNameTypeOrg
        }
      ];
    case '/employees/issues':
      return [
        {
          module: Events.Employee.Module,
          screen: Events.Employee.Screen.Issues.Name,
          ...defaultNameTypeOrg
        }
      ];
    case '/employees/feedback':
      return [
        {
          module: Events.Employee.Module,
          screen: Events.Employee.Screen.Feedback.Name,
          ...defaultNameTypeOrg
        }
      ];
    case '/employees/stoplight':
      return [
        {
          module: Events.Employee.Module,
          screen: Events.Employee.Screen.Stoplights.Name,
          ...defaultNameTypeOrg
        }
      ];
    case '/support/csc/list':
      return [
        {
          module: Events.CSRN.Module,
          screen: Events.CSRN.Screen.List.Name,
          ...defaultNameTypeOrg
        }
      ];
    case '/support/cned/list':
      return [
        {
          module: Events.CNEd.Module,
          screen: Events.CNEd.Screen.List.Name,
          ...defaultNameTypeOrg
        }
      ];
    case '/reports/employee/rounds':
      return [
        {
          module: Events.Report.Module,
          screen: Events.Report.Screen.EmployeeRounds.Name,
          ...defaultNameTypeOrg
        }
      ];
    case '/reports/employee/frequency':
      return [
        {
          module: Events.Report.Module,
          screen: Events.Report.Screen.EmployeeFreq.Name,
          ...defaultNameTypeOrg
        }
      ];
    case '/reports/patient/compliance':
      return [
        {
          module: Events.Report.Module,
          screen: Events.Report.Screen.PatientCompliance.Name,
          ...defaultNameTypeOrg
        }
      ];
    case '/reports/patient/rounds':
      return [
        {
          module: Events.Report.Module,
          screen: Events.Report.Screen.PatientRounds.Name,
          ...defaultNameTypeOrg
        }
      ];
    case '/reports/patient/census':
      return [
        {
          module: Events.Report.Module,
          screen: Events.Report.Screen.PatientCensus.Name,
          ...defaultNameTypeOrg
        }
      ];
    case '/validation/aidet/list':
      return [
        {
          module: Events.AIDETValidation.Module,
          screen: Events.AIDETValidation.Screen.List.Name,
          ...defaultNameTypeOrg
        }
      ];
    case '/validation/nlr/list':
      return [
        {
          module: Events.Validation.Module,
          screen: Events.Validation.Screen.List.Name,
          ...defaultNameTypeOrg
        }
      ];
    case '/validation/bssr/list':
      return [
        {
          module: Events.BSSRValidation.Module,
          screen: Events.BSSRValidation.Screen.List.Name,
          ...defaultNameTypeOrg
        }
      ];
    default:
      return [];
  }
};

// List actions
export function logListClick(filter: ListFilters, view?: string) {
  const { coid } = store.getState().AuthorizedUser.authorizedUser;
  const { userSection } = store.getState().UserReducer;

  const defaultTypeOrg = {
    eventType: 'action',
    org: {
      orgId: coid,
      orgLevel: 'Facility'
    }
  };
  switch (filter) {
    case 'table':
      return [
        userSection === 'employee'
          ? view?.includes('list/user')
            ? {
                module: Events.Employee.Module,
                screen: Events.Employee.Screen.DirectReports.Name,
                eventName:
                  Events.Employee.Screen.DirectReports.Events
                    .Direct_Reports_List_Click,
                ...defaultTypeOrg
              }
            : view?.includes('list/delegate')
            ? {
                module: Events.Employee.Module,
                screen: Events.Employee.Screen.Delegate.Name,
                eventName:
                  Events.Employee.Screen.Delegate.Events.Delegate_List_Click,
                ...defaultTypeOrg
              }
            : {
                module: Events.Employee.Module,
                screen: Events.Employee.Screen.Adhoc.Name,
                eventName: Events.Employee.Screen.Adhoc.Events.AdHoc_List_Click,
                ...defaultTypeOrg
              }
          : userSection === 'validation'
          ? view === 'aidet/list'
            ? {
                module: Events.AIDETValidation.Module,
                screen: Events.AIDETValidation.Screen.List.Name,
                eventName:
                  Events.AIDETValidation.Screen.List.Events
                    .Validation_List_Click,
                ...defaultTypeOrg
              }
            : view === 'bssr/list'
            ? {
                module: Events.BSSRValidation.Module,
                screen: Events.BSSRValidation.Screen.List.Name,
                eventName:
                  Events.BSSRValidation.Screen.List.Events
                    .Validation_List_Click,
                ...defaultTypeOrg
              }
            : {
                module: Events.Validation.Module,
                screen: Events.Validation.Screen.List.Name,
                eventName:
                  Events.Validation.Screen.List.Events.Validation_List_Click,
                ...defaultTypeOrg
              }
          : userSection === 'csc' || userSection === 'cned'
          ? view?.includes('csc/list')
            ? {
                module: Events.CSRN.Module,
                screen: Events.CSRN.Screen.List.Name,
                eventName: Events.CSRN.Screen.List.Events.CSRN_List_Click,
                ...defaultTypeOrg
              }
            : {
                module: Events.CNEd.Module,
                screen: Events.CNEd.Screen.List.Name,
                eventName: Events.CNEd.Screen.List.Events.CNEd_List_Click,
                ...defaultTypeOrg
              }
          : {
              module: Events.Patient.Module,
              screen: Events.Patient.Screen.Census.Name,
              eventName:
                Events.Patient.Screen.Census.Events.Patient_Census_List_Click,
              ...defaultTypeOrg
            }
      ];
    case 'search':
      return [
        userSection === 'employee'
          ? view?.includes('list/user')
            ? {
                module: Events.Employee.Module,
                screen: Events.Employee.Screen.DirectReports.Name,
                eventName:
                  Events.Employee.Screen.DirectReports.Events.Search_Click,
                ...defaultTypeOrg
              }
            : view?.includes('list/delegate')
            ? {
                module: Events.Employee.Module,
                screen: Events.Employee.Screen.Delegate.Name,
                eventName: Events.Employee.Screen.Delegate.Events.Search_Click,
                ...defaultTypeOrg
              }
            : {
                module: Events.Employee.Module,
                screen: Events.Employee.Screen.Adhoc.Name,
                eventName: Events.Employee.Screen.Adhoc.Events.Search_Click,
                ...defaultTypeOrg
              }
          : userSection === 'validation'
          ? view?.includes('aidet/list')
            ? {
                module: Events.AIDETValidation.Module,
                screen: Events.AIDETValidation.Screen.List.Name,
                eventName:
                  Events.AIDETValidation.Screen.List.Events.Search_Click,
                ...defaultTypeOrg
              }
            : view?.includes('bssr/list')
            ? {
                module: Events.BSSRValidation.Module,
                screen: Events.BSSRValidation.Screen.List.Name,
                eventName:
                  Events.BSSRValidation.Screen.List.Events.Search_Click,
                ...defaultTypeOrg
              }
            : {
                module: Events.Validation.Module,
                screen: Events.Validation.Screen.List.Name,
                eventName: Events.Validation.Screen.List.Events.Search_Click,
                ...defaultTypeOrg
              }
          : userSection === 'csc' || userSection === 'cned'
          ? view?.includes('csc/list')
            ? {
                module: Events.CSRN.Module,
                screen: Events.CSRN.Screen.List.Name,
                eventName: Events.CSRN.Screen.List.Events.Search_Click,
                ...defaultTypeOrg
              }
            : {
                module: Events.CNEd.Module,
                screen: Events.CNEd.Screen.List.Name,
                eventName: Events.CNEd.Screen.List.Events.Search_Click,
                ...defaultTypeOrg
              }
          : {
              module: Events.Patient.Module,
              screen: Events.Patient.Screen.Census.Name,
              eventName: Events.Patient.Screen.Census.Events.Search_Click,
              ...defaultTypeOrg
            }
      ];
    case 'search-all':
      return [
        view?.includes('list/adhoc')
          ? {
              module: Events.Employee.Module,
              screen: Events.Employee.Screen.Adhoc.Name,
              eventName:
                Events.Employee.Screen.Adhoc.Events.Search_All_Employees_Click,
              ...defaultTypeOrg
            }
          : []
      ];
    case 'to-do':
      return [
        userSection === 'employee'
          ? view?.includes('list/user')
            ? {
                module: Events.Employee.Module,
                screen: Events.Employee.Screen.DirectReports.Name,
                eventName:
                  Events.Employee.Screen.DirectReports.Events.ToDo_Click,
                ...defaultTypeOrg
              }
            : {
                module: Events.Employee.Module,
                screen: Events.Employee.Screen.Delegate.Name,
                eventName: Events.Employee.Screen.Delegate.Events.ToDo_Click,
                ...defaultTypeOrg
              }
          : userSection === 'validation'
          ? view?.includes('aidet/list')
            ? {
                module: Events.AIDETValidation.Module,
                screen: Events.AIDETValidation.Screen.List.Name,
                eventName: Events.AIDETValidation.Screen.List.Events.ToDo_Click,
                ...defaultTypeOrg
              }
            : view?.includes('bssr/list')
            ? {
                module: Events.BSSRValidation.Module,
                screen: Events.BSSRValidation.Screen.List.Name,
                eventName: Events.BSSRValidation.Screen.List.Events.ToDo_Click,
                ...defaultTypeOrg
              }
            : {
                module: Events.Validation.Module,
                screen: Events.Validation.Screen.List.Name,
                eventName: Events.Validation.Screen.List.Events.ToDo_Click,
                ...defaultTypeOrg
              }
          : {
              module: Events.Patient.Module,
              screen: Events.Patient.Screen.Census.Name,
              eventName: Events.Patient.Screen.Census.Events.ToDo_Click,
              ...defaultTypeOrg
            }
      ];
    case 'completed':
      return [
        userSection === 'employee'
          ? view?.includes('list/user')
            ? {
                module: Events.Employee.Module,
                screen: Events.Employee.Screen.DirectReports.Name,
                eventName:
                  Events.Employee.Screen.DirectReports.Events.Completed_Click,
                ...defaultTypeOrg
              }
            : {
                module: Events.Employee.Module,
                screen: Events.Employee.Screen.Delegate.Name,
                eventName:
                  Events.Employee.Screen.Delegate.Events.Completed_Click,
                ...defaultTypeOrg
              }
          : userSection === 'validation'
          ? view?.includes('aidet/list')
            ? {
                module: Events.AIDETValidation.Module,
                screen: Events.AIDETValidation.Screen.List.Name,
                eventName:
                  Events.AIDETValidation.Screen.List.Events.Completed_Click,
                ...defaultTypeOrg
              }
            : view?.includes('bssr/list')
            ? {
                module: Events.BSSRValidation.Module,
                screen: Events.BSSRValidation.Screen.List.Name,
                eventName:
                  Events.BSSRValidation.Screen.List.Events.Completed_Click,
                ...defaultTypeOrg
              }
            : {
                module: Events.Validation.Module,
                screen: Events.Validation.Screen.List.Name,
                eventName: Events.Validation.Screen.List.Events.Completed_Click,
                ...defaultTypeOrg
              }
          : {
              module: Events.Patient.Module,
              screen: Events.Patient.Screen.Census.Name,
              eventName: Events.Patient.Screen.Census.Events.Completed_Click,
              ...defaultTypeOrg
            }
      ];
    case 'new-hires':
      return [
        view?.includes('list/user')
          ? {
              module: Events.Employee.Module,
              screen: Events.Employee.Screen.DirectReports.Name,
              eventName:
                Events.Employee.Screen.DirectReports.Events.New_Hires_Click,
              ...defaultTypeOrg
            }
          : {
              module: Events.Employee.Module,
              screen: Events.Employee.Screen.Delegate.Name,
              eventName: Events.Employee.Screen.Delegate.Events.New_Hires_Click,
              ...defaultTypeOrg
            }
      ];
    case 'all':
      return [
        userSection === 'employee'
          ? view?.includes('list/user')
            ? {
                module: Events.Employee.Module,
                screen: Events.Employee.Screen.DirectReports.Name,
                eventName:
                  Events.Employee.Screen.DirectReports.Events
                    .HCA_Colleagues_Click,
                ...defaultTypeOrg
              }
            : {
                module: Events.Employee.Module,
                screen: Events.Employee.Screen.Delegate.Name,
                eventName:
                  Events.Employee.Screen.Delegate.Events.HCA_Colleagues_Click,
                ...defaultTypeOrg
              }
          : userSection === 'validation'
          ? view?.includes('aidet/list')
            ? {
                module: Events.AIDETValidation.Module,
                screen: Events.AIDETValidation.Screen.List.Name,
                eventName:
                  Events.AIDETValidation.Screen.List.Events
                    .Validation_All_Click,
                ...defaultTypeOrg
              }
            : view?.includes('bssr/list')
            ? {
                module: Events.BSSRValidation.Module,
                screen: Events.BSSRValidation.Screen.List.Name,
                eventName:
                  Events.BSSRValidation.Screen.List.Events.Validation_All_Click,
                ...defaultTypeOrg
              }
            : {
                module: Events.Validation.Module,
                screen: Events.Validation.Screen.List.Name,
                eventName:
                  Events.Validation.Screen.List.Events.Validation_All_Click,
                ...defaultTypeOrg
              }
          : view?.includes('csrn')
          ? {
              module: Events.CSRN.Module,
              screen: Events.CSRN.Screen.List.Name,
              eventName: Events.CSRN.Screen.List.Events.CSRN_All_Click,
              ...defaultTypeOrg
            }
          : {
              module: Events.CNEd.Module,
              screen: Events.CNEd.Screen.List.Name,
              eventName: Events.CNEd.Screen.List.Events.CNEd_All_Click,
              ...defaultTypeOrg
            }
      ];
    case 'no-round':
      return view?.includes('csrn')
        ? [
            {
              module: Events.CSRN.Module,
              screen: Events.CSRN.Screen.List.Name,
              eventName: Events.CSRN.Screen.List.Events.No_Round_Click,
              ...defaultTypeOrg
            }
          ]
        : [
            {
              module: Events.CNEd.Module,
              screen: Events.CNEd.Screen.List.Name,
              eventName: Events.CNEd.Screen.List.Events.No_Round_Click,
              ...defaultTypeOrg
            }
          ];
    case 'recently-completed':
      return view?.includes('csrn')
        ? [
            {
              module: Events.CSRN.Module,
              screen: Events.CSRN.Screen.List.Name,
              eventName:
                Events.CSRN.Screen.List.Events.Recently_Completed_Click,
              ...defaultTypeOrg
            }
          ]
        : [
            {
              module: Events.CNEd.Module,
              screen: Events.CNEd.Screen.List.Name,
              eventName:
                Events.CNEd.Screen.List.Events.Recently_Completed_Click,
              ...defaultTypeOrg
            }
          ];
    case 'new-nurses':
      return view?.includes('csrn')
        ? [
            {
              module: Events.CSRN.Module,
              screen: Events.CSRN.Screen.List.Name,
              eventName: Events.CSRN.Screen.List.Events.New_Nurses_Click,
              ...defaultTypeOrg
            }
          ]
        : [
            {
              module: Events.CNEd.Module,
              screen: Events.CNEd.Screen.List.Name,
              eventName: Events.CNEd.Screen.List.Events.New_Nurses_Click,
              ...defaultTypeOrg
            }
          ];
    case 'new-to-hca-nurses':
      return view?.includes('csrn')
        ? [
            {
              module: Events.CSRN.Module,
              screen: Events.CSRN.Screen.List.Name,
              eventName: Events.CSRN.Screen.List.Events.New_to_HCA_Nurses_Click,
              ...defaultTypeOrg
            }
          ]
        : [
            {
              module: Events.CNEd.Module,
              screen: Events.CNEd.Screen.List.Name,
              eventName: Events.CNEd.Screen.List.Events.New_to_HCA_Nurses_Click,
              ...defaultTypeOrg
            }
          ];
    case 'new-to-dept-nurses':
      return view?.includes('csrn')
        ? [
            {
              module: Events.CSRN.Module,
              screen: Events.CSRN.Screen.List.Name,
              eventName:
                Events.CSRN.Screen.List.Events.New_to_Dept_Nurses_Click,
              ...defaultTypeOrg
            }
          ]
        : [
            {
              module: Events.CNEd.Module,
              screen: Events.CNEd.Screen.List.Name,
              eventName:
                Events.CNEd.Screen.List.Events.New_to_Dept_Nurses_Click,
              ...defaultTypeOrg
            }
          ];
    // Validation-specific list filter events
    case 'expert':
      return view?.includes('aidet/list')
        ? [
            {
              module: Events.AIDETValidation.Module,
              screen: Events.AIDETValidation.Screen.List.Name,
              eventName: Events.AIDETValidation.Screen.List.Events.Expert_Click,
              ...defaultTypeOrg
            }
          ]
        : view?.includes('bssr/list')
        ? [
            {
              module: Events.BSSRValidation.Module,
              screen: Events.BSSRValidation.Screen.List.Name,
              eventName: Events.BSSRValidation.Screen.List.Events.Expert_Click,
              ...defaultTypeOrg
            }
          ]
        : [
            {
              module: Events.Validation.Module,
              screen: Events.Validation.Screen.List.Name,
              eventName: Events.Validation.Screen.List.Events.Expert_Click,
              ...defaultTypeOrg
            }
          ];
    case 'competent':
      return view?.includes('aidet/list')
        ? [
            {
              module: Events.AIDETValidation.Module,
              screen: Events.AIDETValidation.Screen.List.Name,
              eventName:
                Events.AIDETValidation.Screen.List.Events.Competent_Click,
              ...defaultTypeOrg
            }
          ]
        : view?.includes('bssr/list')
        ? [
            {
              module: Events.BSSRValidation.Module,
              screen: Events.BSSRValidation.Screen.List.Name,
              eventName:
                Events.BSSRValidation.Screen.List.Events.Competent_Click,
              ...defaultTypeOrg
            }
          ]
        : [
            {
              module: Events.Validation.Module,
              screen: Events.Validation.Screen.List.Name,
              eventName: Events.Validation.Screen.List.Events.Competent_Click,
              ...defaultTypeOrg
            }
          ];
    case 'developing':
      return view?.includes('aidet/list')
        ? [
            {
              module: Events.AIDETValidation.Module,
              screen: Events.AIDETValidation.Screen.List.Name,
              eventName:
                Events.AIDETValidation.Screen.List.Events.Developing_Click,
              ...defaultTypeOrg
            }
          ]
        : view?.includes('bssr/list')
        ? [
            {
              module: Events.BSSRValidation.Module,
              screen: Events.BSSRValidation.Screen.List.Name,
              eventName:
                Events.BSSRValidation.Screen.List.Events.Developing_Click,
              ...defaultTypeOrg
            }
          ]
        : [
            {
              module: Events.Validation.Module,
              screen: Events.Validation.Screen.List.Name,
              eventName: Events.Validation.Screen.List.Events.Developing_Click,
              ...defaultTypeOrg
            }
          ];
    default:
      console.log('No task type for event');
      return [];
  }
}

// Round actions
export function logRoundProfile(supportType?: string) {
  const { coid } = store.getState().AuthorizedUser.authorizedUser;
  const { userSection } = store.getState().UserReducer;

  const defaultNameTypeOrg = {
    eventName: null,
    eventType: 'start',
    org: {
      orgId: coid,
      orgLevel: 'Facility'
    }
  };
  return [
    userSection === 'employee'
      ? {
          module: Events.Employee.Module,
          screen: Events.Employee.Screen.Profile.Name,
          ...defaultNameTypeOrg
        }
      : userSection === 'validation'
      ? supportType === 'aidetValidation'
        ? {
            module: Events.AIDETValidation.Module,
            screen: Events.AIDETValidation.Screen.Profile.Name,
            ...defaultNameTypeOrg
          }
        : supportType === 'bssrValidation'
        ? {
            module: Events.BSSRValidation.Module,
            screen: Events.BSSRValidation.Screen.Profile.Name,
            ...defaultNameTypeOrg
          }
        : {
            module: Events.Validation.Module,
            screen: Events.Validation.Screen.Profile.Name,
            ...defaultNameTypeOrg
          }
      : userSection === 'csc' || userSection === 'cned'
      ? userSection === 'csc'
        ? {
            module: Events.CSRN.Module,
            screen: Events.CSRN.Screen.Profile.Name,
            ...defaultNameTypeOrg
          }
        : {
            module: Events.CNEd.Module,
            screen: Events.CNEd.Screen.Profile.Name,
            ...defaultNameTypeOrg
          }
      : {
          module: Events.Patient.Module,
          screen: Events.Patient.Screen.Profile.Name,
          ...defaultNameTypeOrg
        }
  ];
}

export function logRoundProfileClick(
  event: HistorySideNavFilters | 'date',
  supportType?: string
) {
  const { coid } = store.getState().AuthorizedUser.authorizedUser;
  const { userSection } = store.getState().UserReducer;

  const defaultTypeOrg = {
    eventType: 'action',
    org: {
      orgId: coid,
      orgLevel: 'Facility'
    }
  };

  switch (event) {
    case 'past-notes':
      return [
        userSection === 'employee'
          ? {
              module: Events.Employee.Module,
              screen: Events.Employee.Screen.Profile.Name,
              eventName: Events.Employee.Screen.Profile.Events.Notes_Click,
              ...defaultTypeOrg
            }
          : userSection === 'validation'
          ? supportType === 'aidetValidation'
            ? {
                module: Events.AIDETValidation.Module,
                screen: Events.AIDETValidation.Screen.Profile.Name,
                eventName:
                  Events.AIDETValidation.Screen.Profile.Events.Notes_Click,
                ...defaultTypeOrg
              }
            : supportType === 'bssrValidation'
            ? {
                module: Events.BSSRValidation.Module,
                screen: Events.BSSRValidation.Screen.Profile.Name,
                eventName:
                  Events.BSSRValidation.Screen.Profile.Events.Notes_Click,
                ...defaultTypeOrg
              }
            : {
                module: Events.Validation.Module,
                screen: Events.Validation.Screen.Profile.Name,
                eventName: Events.Validation.Screen.Profile.Events.Notes_Click,
                ...defaultTypeOrg
              }
          : userSection === 'csc' || userSection === 'cned'
          ? userSection === 'csc'
            ? {
                module: Events.CSRN.Module,
                screen: Events.CSRN.Screen.Profile.Name,
                eventName: Events.CSRN.Screen.Profile.Events.Notes_Click,
                ...defaultTypeOrg
              }
            : {
                module: Events.CNEd.Module,
                screen: Events.CNEd.Screen.Profile.Name,
                eventName: Events.CNEd.Screen.Profile.Events.Notes_Click,
                ...defaultTypeOrg
              }
          : {
              module: Events.Patient.Module,
              screen: Events.Patient.Screen.Profile.Name,
              eventName: Events.Patient.Screen.Profile.Events.Notes_Click,
              ...defaultTypeOrg
            }
      ];
    case 'save-notes':
      return [
        userSection === 'employee'
          ? {
              module: Events.Employee.Module,
              screen: Events.Employee.Screen.Profile.Name,
              eventName: Events.Employee.Screen.Profile.Events.Save_Notes_Click,
              ...defaultTypeOrg
            }
          : userSection === 'validation'
          ? supportType === 'aidetValidation'
            ? {
                module: Events.AIDETValidation.Module,
                screen: Events.AIDETValidation.Screen.Profile.Name,
                eventName:
                  Events.AIDETValidation.Screen.Profile.Events.Save_Notes_Click,
                ...defaultTypeOrg
              }
            : supportType === 'bssrValidation'
            ? {
                module: Events.BSSRValidation.Module,
                screen: Events.BSSRValidation.Screen.Profile.Name,
                eventName:
                  Events.BSSRValidation.Screen.Profile.Events.Save_Notes_Click,
                ...defaultTypeOrg
              }
            : {
                module: Events.Validation.Module,
                screen: Events.Validation.Screen.Profile.Name,
                eventName:
                  Events.Validation.Screen.Profile.Events.Save_Notes_Click,
                ...defaultTypeOrg
              }
          : userSection === 'csc' || userSection === 'cned'
          ? userSection === 'csc'
            ? {
                module: Events.CSRN.Module,
                screen: Events.CSRN.Screen.Profile.Name,
                eventName: Events.CSRN.Screen.Profile.Events.SaveNotes_Click,
                ...defaultTypeOrg
              }
            : {
                module: Events.CNEd.Module,
                screen: Events.CNEd.Screen.Profile.Name,
                eventName: Events.CNEd.Screen.Profile.Events.Save_Notes_Click,
                ...defaultTypeOrg
              }
          : {
              module: Events.Patient.Module,
              screen: Events.Patient.Screen.Profile.Name,
              eventName: Events.Patient.Screen.Profile.Events.SaveNotes_Click,
              ...defaultTypeOrg
            }
      ];
    case 'past-rounds':
      return [
        userSection === 'employee'
          ? {
              module: Events.Employee.Module,
              screen: Events.Employee.Screen.Profile.Name,
              eventName:
                Events.Employee.Screen.Profile.Events.Past_Rounds_Click,
              ...defaultTypeOrg
            }
          : userSection === 'validation'
          ? supportType === 'aidetValidation'
            ? {
                module: Events.AIDETValidation.Module,
                screen: Events.AIDETValidation.Screen.Profile.Name,
                eventName:
                  Events.AIDETValidation.Screen.Profile.Events
                    .Past_Rounds_Click,
                ...defaultTypeOrg
              }
            : supportType === 'bssrValidation'
            ? {
                module: Events.BSSRValidation.Module,
                screen: Events.BSSRValidation.Screen.Profile.Name,
                eventName:
                  Events.BSSRValidation.Screen.Profile.Events.Past_Rounds_Click,
                ...defaultTypeOrg
              }
            : {
                module: Events.Validation.Module,
                screen: Events.Validation.Screen.Profile.Name,
                eventName:
                  Events.Validation.Screen.Profile.Events.Past_Rounds_Click,
                ...defaultTypeOrg
              }
          : userSection === 'csc' || userSection === 'cned'
          ? userSection === 'csc'
            ? {
                module: Events.CSRN.Module,
                screen: Events.CSRN.Screen.Profile.Name,
                eventName: Events.CSRN.Screen.Profile.Events.Past_Rounds_Click,
                ...defaultTypeOrg
              }
            : {
                module: Events.CNEd.Module,
                screen: Events.CNEd.Screen.Profile.Name,
                eventName: Events.CNEd.Screen.Profile.Events.Past_Rounds_Click,
                ...defaultTypeOrg
              }
          : {
              module: Events.Patient.Module,
              screen: Events.Patient.Screen.Profile.Name,
              eventName: Events.Patient.Screen.Profile.Events.Past_Rounds_Click,
              ...defaultTypeOrg
            }
      ];
    case 'past-issues':
      return [
        userSection === 'employee'
          ? {
              module: Events.Employee.Module,
              screen: Events.Employee.Screen.Profile.Name,
              eventName:
                Events.Employee.Screen.Profile.Events.Past_Issues_Click,
              ...defaultTypeOrg
            }
          : {
              module: Events.Patient.Module,
              screen: Events.Patient.Screen.Profile.Name,
              eventName: Events.Patient.Screen.Profile.Events.Past_Issues_Click,
              ...defaultTypeOrg
            }
      ];
    case 'past-feedback':
      return [
        userSection === 'employee'
          ? {
              module: Events.Employee.Module,
              screen: Events.Employee.Screen.Profile.Name,
              eventName:
                Events.Employee.Screen.Profile.Events.Past_Feedback_Click,
              ...defaultTypeOrg
            }
          : {
              module: Events.Patient.Module,
              screen: Events.Patient.Screen.Profile.Name,
              eventName:
                Events.Patient.Screen.Profile.Events.Past_Feedback_Click,
              ...defaultTypeOrg
            }
      ];
    case 'date':
      return [
        userSection === 'employee'
          ? {
              module: Events.Employee.Module,
              screen: Events.Employee.Screen.Profile.Name,
              eventName: Events.Employee.Screen.Profile.Events.Calendar_Click,
              ...defaultTypeOrg
            }
          : userSection === 'csc' || userSection === 'cned'
          ? userSection === 'csc'
            ? {
                module: Events.CSRN.Module,
                screen: Events.CSRN.Screen.Profile.Name,
                eventName: Events.CSRN.Screen.Profile.Events.Calendar_Click,
                ...defaultTypeOrg
              }
            : {
                module: Events.CNEd.Module,
                screen: Events.CNEd.Screen.Profile.Name,
                eventName: Events.CNEd.Screen.Profile.Events.Calendar_Click,
                ...defaultTypeOrg
              }
          : {
              module: Events.Patient.Module,
              screen: Events.Patient.Screen.Profile.Name,
              eventName: Events.Patient.Screen.Profile.Events.Yesterday_Click,
              ...defaultTypeOrg
            }
      ];
    default:
      console.log('No type for event');
      return [];
  }
}

export function logRoundClick(event: RoundEvents, supportType?: string) {
  const { coid } = store.getState().AuthorizedUser.authorizedUser;
  const { currentRound } = store.getState().RoundReducer;
  const { userSection } = store.getState().UserReducer;

  const defaultTypeOrg = {
    eventType: 'action',
    org: {
      orgId: coid,
      orgLevel: 'Facility'
    }
  };
  switch (event) {
    case 'start':
      return [
        userSection === 'employee'
          ? {
              module: Events.Employee.Module,
              screen: Events.Employee.Screen.Profile.Name,
              eventName:
                Events.Employee.Screen.Profile.Events.Start_a_New_Round_Click,
              ...defaultTypeOrg
            }
          : userSection === 'validation'
          ? supportType === 'aidetValidation'
            ? {
                module: Events.AIDETValidation.Module,
                screen: Events.AIDETValidation.Screen.Profile.Name,
                eventName:
                  Events.AIDETValidation.Screen.Profile.Events
                    .Start_a_New_Round_Click,
                ...defaultTypeOrg
              }
            : supportType === 'bssrValidation'
            ? {
                module: Events.BSSRValidation.Module,
                screen: Events.BSSRValidation.Screen.Profile.Name,
                eventName:
                  Events.BSSRValidation.Screen.Profile.Events
                    .Start_a_New_Round_Click,
                ...defaultTypeOrg
              }
            : {
                module: Events.Validation.Module,
                screen: Events.Validation.Screen.Profile.Name,
                eventName:
                  Events.Validation.Screen.Profile.Events
                    .Start_a_New_Round_Click,
                ...defaultTypeOrg
              }
          : userSection === 'csc' || userSection === 'cned'
          ? userSection === 'csc'
            ? {
                module: Events.CSRN.Module,
                screen: Events.CSRN.Screen.Profile.Name,
                eventName:
                  Events.CSRN.Screen.Profile.Events.Start_a_New_Round_Click,
                ...defaultTypeOrg
              }
            : {
                module: Events.CNEd.Module,
                screen: Events.CNEd.Screen.Profile.Name,
                eventName:
                  Events.CNEd.Screen.Profile.Events.Start_a_New_Round_Click,
                ...defaultTypeOrg
              }
          : {
              module: Events.Patient.Module,
              screen: Events.Patient.Screen.Profile.Name,
              eventName:
                Events.Patient.Screen.Profile.Events.Start_a_New_Round_Click,
              ...defaultTypeOrg
            }
      ];
    case 'cancel':
      return [
        userSection === 'employee'
          ? {
              module: Events.Employee.Module,
              screen: Events.Employee.Screen.Profile.Name,
              eventName:
                Events.Employee.Screen.Profile.Events.Cancel_Round_Click,
              ...defaultTypeOrg
            }
          : userSection === 'validation'
          ? supportType === 'aidetValidation'
            ? {
                module: Events.AIDETValidation.Module,
                screen: Events.AIDETValidation.Screen.Profile.Name,
                eventName:
                  Events.AIDETValidation.Screen.Profile.Events
                    .Cancel_Round_Click,
                ...defaultTypeOrg
              }
            : supportType === 'bssrValidation'
            ? {
                module: Events.BSSRValidation.Module,
                screen: Events.BSSRValidation.Screen.Profile.Name,
                eventName:
                  Events.BSSRValidation.Screen.Profile.Events
                    .Cancel_Round_Click,
                ...defaultTypeOrg
              }
            : {
                module: Events.Validation.Module,
                screen: Events.Validation.Screen.Profile.Name,
                eventName:
                  Events.Validation.Screen.Profile.Events.Cancel_Round_Click,
                ...defaultTypeOrg
              }
          : userSection === 'csc' || userSection === 'cned'
          ? userSection === 'csc'
            ? {
                module: Events.CSRN.Module,
                screen: Events.CSRN.Screen.Profile.Name,
                eventName: Events.CSRN.Screen.Profile.Events.Cancel_Round_Click,
                ...defaultTypeOrg
              }
            : {
                module: Events.CNEd.Module,
                screen: Events.CNEd.Screen.Profile.Name,
                eventName: Events.CNEd.Screen.Profile.Events.Cancel_Round_Click,
                ...defaultTypeOrg
              }
          : {
              module: Events.Patient.Module,
              screen: Events.Patient.Screen.Profile.Name,
              eventName:
                Events.Patient.Screen.Profile.Events.Cancel_Round_Click,
              ...defaultTypeOrg
            }
      ];
    case 'complete':
      return [
        userSection === 'employee'
          ? {
              module: Events.Employee.Module,
              screen: Events.Employee.Screen.Profile.Name,
              eventName:
                Events.Employee.Screen.Profile.Events.Complete_Round_Click,
              param: {
                roundId: currentRound.roundId
              },
              ...defaultTypeOrg
            }
          : userSection === 'validation'
          ? supportType === 'aidetValidation'
            ? {
                module: Events.AIDETValidation.Module,
                screen: Events.AIDETValidation.Screen.Profile.Name,
                eventName:
                  Events.AIDETValidation.Screen.Profile.Events
                    .Complete_Round_Click,
                param: {
                  roundId: currentRound.roundId
                },
                ...defaultTypeOrg
              }
            : supportType === 'bssrValidation'
            ? {
                module: Events.BSSRValidation.Module,
                screen: Events.BSSRValidation.Screen.Profile.Name,
                eventName:
                  Events.BSSRValidation.Screen.Profile.Events
                    .Complete_Round_Click,
                param: {
                  roundId: currentRound.roundId
                },
                ...defaultTypeOrg
              }
            : {
                module: Events.Validation.Module,
                screen: Events.Validation.Screen.Profile.Name,
                eventName:
                  Events.Validation.Screen.Profile.Events.Complete_Round_Click,
                param: {
                  roundId: currentRound.roundId
                },
                ...defaultTypeOrg
              }
          : userSection === 'csc' || userSection === 'cned'
          ? userSection === 'csc'
            ? {
                module: Events.CSRN.Module,
                screen: Events.CSRN.Screen.Profile.Name,
                eventName:
                  Events.CSRN.Screen.Profile.Events.Complete_Round_Click,
                param: {
                  roundId: currentRound.roundId
                },
                ...defaultTypeOrg
              }
            : {
                module: Events.CNEd.Module,
                screen: Events.CNEd.Screen.Profile.Name,
                eventName:
                  Events.CNEd.Screen.Profile.Events.Complete_Round_Click,
                param: {
                  roundId: currentRound.roundId
                },
                ...defaultTypeOrg
              }
          : {
              module: Events.Patient.Module,
              screen: Events.Patient.Screen.Profile.Name,
              eventName:
                Events.Patient.Screen.Profile.Events.Complete_Round_Click,
              param: {
                roundId: currentRound.roundId
              },
              ...defaultTypeOrg
            }
      ];
    default:
      console.log('No type for event');
      return [];
  }
}

// Report actions
export function logHRInsightsClick() {
  const { coid } = store.getState().AuthorizedUser.authorizedUser;

  const defaultTypeOrg = {
    eventType: 'action',
    org: {
      orgId: coid,
      orgLevel: 'Facility'
    }
  };
  return [
    {
      module: Events.Report.Module,
      screen: Events.Report.Screen.Insights.Name,
      eventName: Events.Report.Screen.Insights.Events.HR_Insights_Click,
      ...defaultTypeOrg
    }
  ];
}
export function logCOGReportClick() {
  const { coid } = store.getState().AuthorizedUser.authorizedUser;

  const defaultTypeOrg = {
    eventType: 'action',
    org: {
      orgId: coid,
      orgLevel: 'Facility'
    }
  };
  return [
    {
      module: Events.Report.Module,
      screen: Events.Report.Screen.COG.Name,
      eventName: Events.Report.Screen.COG.Events.COG_Patient_Report_Click,
      ...defaultTypeOrg
    }
  ];
}

export function logReportsClick(view: string, event: ReportEvents) {
  const { coid } = store.getState().AuthorizedUser.authorizedUser;

  const defaultTypeOrg = {
    eventType: 'action',
    org: {
      orgId: coid,
      orgLevel: 'Facility'
    }
  };
  switch (view) {
    case 'employee-compliance':
      return [
        {
          module: Events.Report.Module,
          screen: Events.Report.Screen.EmployeeCompliance.Name,
          eventName:
            event === 'date-range'
              ? Events.Report.Screen.EmployeeCompliance.Events.Date_Range_Click
              : event === 'filter'
              ? Events.Report.Screen.EmployeeCompliance.Events.Filter_Click
              : event === 'export'
              ? Events.Report.Screen.EmployeeCompliance.Events.Export_CSV_Click
              : Events.Report.Screen.EmployeeCompliance.Events
                  .Download_PDF_Click,
          ...defaultTypeOrg
        }
      ];
    case 'employee-rounds':
      return [
        {
          module: Events.Report.Module,
          screen: Events.Report.Screen.EmployeeRounds.Name,
          eventName:
            event === 'date-range'
              ? Events.Report.Screen.EmployeeRounds.Events.Date_Range_Click
              : event === 'filter'
              ? Events.Report.Screen.EmployeeRounds.Events.Filter_Click
              : event === 'export'
              ? Events.Report.Screen.EmployeeRounds.Events.Export_CSV_Click
              : event === 'download-pdf'
              ? Events.Report.Screen.EmployeeRounds.Events.Download_PDF_Click
              : Events.Report.Screen.EmployeeRounds.Events.Search_Click,
          ...defaultTypeOrg
        }
      ];
    case 'employee-frequency':
      return [
        {
          module: Events.Report.Module,
          screen: Events.Report.Screen.EmployeeFreq.Name,
          eventName:
            event === 'date-range'
              ? Events.Report.Screen.EmployeeFreq.Events.Date_Range_Click
              : event === 'filter'
              ? Events.Report.Screen.EmployeeFreq.Events.Filter_Click
              : event === 'export'
              ? Events.Report.Screen.EmployeeFreq.Events.Export_CSV_Click
              : event === 'download-pdf'
              ? Events.Report.Screen.EmployeeFreq.Events.Download_PDF_Click
              : Events.Report.Screen.EmployeeFreq.Events.Search_Click,
          ...defaultTypeOrg
        }
      ];
    case 'patient-compliance':
      return [
        {
          module: Events.Report.Module,
          screen: Events.Report.Screen.PatientCompliance.Name,
          eventName:
            event === 'date-range'
              ? Events.Report.Screen.PatientCompliance.Events.Date_Range_Click
              : event === 'info'
              ? Events.Report.Screen.PatientCompliance.Events.Info_Click
              : event === 'export'
              ? Events.Report.Screen.PatientCompliance.Events.Export_CSV_Click
              : event === 'download-pdf'
              ? Events.Report.Screen.PatientCompliance.Events.Download_PDF_Click
              : Events.Report.Screen.PatientCompliance.Events
                  .Location_Dropdown_Click,
          ...defaultTypeOrg
        }
      ];
    case 'patient-rounds':
      return [
        {
          module: Events.Report.Module,
          screen: Events.Report.Screen.PatientRounds.Name,
          eventName:
            event === 'filter'
              ? Events.Report.Screen.PatientRounds.Events.Filter_Click
              : event === 'info'
              ? Events.Report.Screen.PatientRounds.Events.Info_Click
              : event === 'export'
              ? Events.Report.Screen.PatientRounds.Events.Export_CSV_Click
              : event === 'search'
              ? Events.Report.Screen.PatientRounds.Events.Search_Click
              : event === 'download-pdf'
              ? Events.Report.Screen.PatientRounds.Events.Download_PDF_Click
              : Events.Report.Screen.PatientRounds.Events
                  .Location_Dropdown_Click,
          ...defaultTypeOrg
        }
      ];
    case 'patient-census':
      return [
        {
          module: Events.Report.Module,
          screen: Events.Report.Screen.PatientCensus.Name,
          eventName:
            event === 'calendar'
              ? Events.Report.Screen.PatientCensus.Events.Calendar_Click
              : event === 'info'
              ? Events.Report.Screen.PatientCensus.Events.Info_Click
              : event === 'export'
              ? Events.Report.Screen.PatientCensus.Events.Export_CSV_Click
              : event === 'search'
              ? Events.Report.Screen.PatientCensus.Events.Search_Click
              : event === 'download-pdf'
              ? Events.Report.Screen.PatientCensus.Events.Download_PDF_Click
              : Events.Report.Screen.PatientCensus.Events
                  .Location_Dropdown_Click,
          ...defaultTypeOrg
        }
      ];
    case 'patient-summary':
      return [
        {
          module: Events.Report.Module,
          screen: Events.Report.Screen.PatientSummary.Name,
          eventName:
            event === 'compliance'
              ? Events.Report.Screen.PatientSummary.Events.Compliance_Click
              : event === 'issue'
              ? Events.Report.Screen.PatientSummary.Events.Issue_Click
              : event === 'recognition'
              ? Events.Report.Screen.PatientSummary.Events
                  .Feedback_Recognition_Click
              : event === 'stoplight'
              ? Events.Report.Screen.PatientSummary.Events.Stoplight_Click
              : Events.Report.Screen.PatientSummary.Events
                  .Feedback_Coaching_Click,
          ...defaultTypeOrg
        }
      ];
    case 'employee-summary':
      return [
        {
          module: Events.Report.Module,
          screen: Events.Report.Screen.EmployeeSummary.Name,
          eventName:
            event === 'compliance'
              ? Events.Report.Screen.EmployeeSummary.Events.Compliance_Click
              : event === 'issue'
              ? Events.Report.Screen.EmployeeSummary.Events.Issue_Click
              : event === 'recognition'
              ? Events.Report.Screen.EmployeeSummary.Events
                  .Feedback_Recognition_Click
              : event === 'stoplight'
              ? Events.Report.Screen.EmployeeSummary.Events.Stoplight_Click
              : Events.Report.Screen.EmployeeSummary.Events
                  .Feedback_Coaching_Click,
          ...defaultTypeOrg
        }
      ];
    default:
      console.log('No report view for event');
      return [];
  }
}

// Report views
export function logRoundProfileFromReports(
  roundingType: 'employee' | 'patient'
) {
  const { coid } = store.getState().AuthorizedUser.authorizedUser;

  const defaultNameTypeOrg = {
    eventName: null,
    eventType: 'start',
    org: {
      orgId: coid,
      orgLevel: 'Facility'
    }
  };
  return [
    roundingType === 'employee'
      ? {
          module: Events.Employee.Module,
          screen: Events.Employee.Screen.Profile.Name,
          ...defaultNameTypeOrg
        }
      : {
          module: Events.Patient.Module,
          screen: Events.Patient.Screen.Profile.Name,
          ...defaultNameTypeOrg
        }
  ];
}

// Help
export function logHelpClick(event: HelpEvents) {
  const { coid } = store.getState().AuthorizedUser.authorizedUser;

  const defaultTypeOrg = {
    eventType: 'action',
    org: {
      orgId: coid,
      orgLevel: 'Facility'
    }
  };
  switch (event) {
    case 'sharepoint':
      return [
        {
          module: Events.Help.Module,
          screen: Events.Help.Screen.Sharepoint.Name,
          eventName:
            Events.Help.Screen.Sharepoint.Events.Orbit_Sharepoint_Site_Click,
          ...defaultTypeOrg
        }
      ];
    case 'health-stream':
      return [
        {
          module: Events.Help.Module,
          screen: Events.Help.Screen.HS.Name,
          eventName: Events.Help.Screen.HS.Events.HealthStream_Click,
          ...defaultTypeOrg
        }
      ];
    case 'hr-emp-rounding':
      return [
        {
          module: Events.Help.Module,
          screen: Events.Help.Screen.HR.Name,
          eventName: Events.Help.Screen.HR.Events.HR_Employee_Rounding_Click,
          ...defaultTypeOrg
        }
      ];
    default:
      console.log('No type for event');
      return [];
  }
}

export function logDelegateClick(
  filter: DelegateDropdownFilters,
  view?: string
) {
  const { coid } = store.getState().AuthorizedUser.authorizedUser;

  const defaultTypeOrg = {
    eventType: 'action',
    org: {
      orgId: coid,
      orgLevel: 'Facility'
    }
  };
  switch (filter) {
    case 'direct-report':
      return view?.includes('directs')
        ? [
            {
              module: Events.Employee.Module,
              screen: Events.Employee.Screen.DirectReports.Name,
              eventName:
                Events.Employee.Screen.DirectReports.Events.List_Dropdown_Click,
              ...defaultTypeOrg
            }
          ]
        : [];
    case 'delegate':
      return view?.includes('list')
        ? [
            {
              module: Events.Employee.Module,
              screen: Events.Employee.Screen.Delegate.Name,
              eventName:
                Events.Employee.Screen.Delegate.Events.List_Dropdown_Click,
              ...defaultTypeOrg
            }
          ]
        : [];
    default:
      console.log('No delegate type for event');
      return [];
  }
}

export function logReportToGHRClick() {
  const { coid } = store.getState().AuthorizedUser.authorizedUser;

  const defaultTypeOrg = {
    eventType: 'action',
    org: {
      orgId: coid,
      orgLevel: 'Facility'
    }
  };
  return [
    {
      module: Events.EmployeeRoundingSettings.Module,
      screen: Events.EmployeeRoundingSettings.Screen.DirectReportsList.Name,
      eventName:
        Events.EmployeeRoundingSettings.Screen.DirectReportsList.Events
          .Report_to_GHR_Click,
      ...defaultTypeOrg
    }
  ];
}

// TODO: Leaving in case complete is added again
// export const tableLogTrackingComplete = (path: string | null) => {
//   const { coid } = store.getState().AuthorizedUser.authorizedUser;
//   switch (path) {
//     case '/patients/census':
//       return logTrackingEvent([
//         {
//           eventName: Events.Patient.Patient_List,
//           ...{
//             action: 'complete',
//             org: {
//               orgId: coid,
//               orgLevel: 'Facility'
//             }
//           }
//         }
//       ]);
//     case '/patients/issues':
//       return logTrackingEvent([
//         {
//           eventName: Events.Patient.Patient_Issues,
//           ...{
//             action: 'complete',
//             org: {
//               orgId: coid,
//               orgLevel: 'Facility'
//             }
//           }
//         }
//       ]);
//     case '/patients/feedback':
//       return logTrackingEvent([
//         {
//           eventName: Events.Patient.Patient_Feedback,
//           ...{
//             action: 'complete',
//             org: {
//               orgId: coid,
//               orgLevel: 'Facility'
//             }
//           }
//         }
//       ]);
//     case '/patients/stoplight':
//       return logTrackingEvent([
//         {
//           eventName: Events.Patient.Patient_Stoplight,
//           ...{
//             action: 'complete',
//             org: {
//               orgId: coid,
//               orgLevel: 'Facility'
//             }
//           }
//         }
//       ]);
//     case '/patients/profile':
//       return logTrackingEvent([
//         {
//           eventName: Events.Patient.Patient_Round,
//           ...{
//             action: 'complete',
//             org: {
//               orgId: coid,
//               orgLevel: 'Facility'
//             }
//           }
//         }
//       ]);
//     case '/employees/list':
//       return logTrackingEvent([
//         {
//           eventName: Events.Employee.Employee_List,
//           ...{
//             action: 'complete',
//             org: {
//               orgId: coid,
//               orgLevel: 'Facility'
//             }
//           }
//         }
//       ]);
//     case '/employees/issues':
//       return logTrackingEvent([
//         {
//           eventName: Events.Employee.Employee_Issues,
//           ...{
//             action: 'complete',
//             org: {
//               orgId: coid,
//               orgLevel: 'Facility'
//             }
//           }
//         }
//       ]);
//     case '/employees/feedback':
//       return logTrackingEvent([
//         {
//           eventName: Events.Employee.Employee_Feedback,
//           ...{
//             action: 'complete',
//             org: {
//               orgId: coid,
//               orgLevel: 'Facility'
//             }
//           }
//         }
//       ]);
//     case '/employees/stoplight':
//       return logTrackingEvent([
//         {
//           eventName: Events.Employee.Employee_Stoplight,
//           ...{
//             action: 'complete',
//             org: {
//               orgId: coid,
//               orgLevel: 'Facility'
//             }
//           }
//         }
//       ]);
//     case '/employees/profile':
//       return logTrackingEvent([
//         {
//           eventName: Events.Employee.Employee_Round,
//           ...{
//             action: 'complete',
//             org: {
//               orgId: coid,
//               orgLevel: 'Facility'
//             }
//           }
//         }
//       ]);
//     case '/reports/employee/rounds':
//       return logTrackingEvent([
//         {
//           eventName: Events.Report.Employee_Reports_Rounds,
//           ...{
//             action: 'complete',
//             org: {
//               orgId: coid,
//               orgLevel: 'Facility'
//             }
//           }
//         }
//       ]);
//     case '/reports/employee':
//       return logTrackingEvent([
//         {
//           eventName: Events.Report.Employee_Reports_Rounds,
//           ...{
//             action: 'complete',
//             org: {
//               orgId: coid,
//               orgLevel: 'Facility'
//             }
//           }
//         }
//       ]);
//     case '/reports/employee/frequency':
//       return logTrackingEvent([
//         {
//           eventName: Events.Report.Employee_Reports_Frequency,
//           ...{
//             action: 'complete',
//             org: {
//               orgId: coid,
//               orgLevel: 'Facility'
//             }
//           }
//         }
//       ]);
//     case '/reports/patient/compliance':
//       return logTrackingEvent([
//         {
//           eventName: Events.Report.Patient_Reports_Compliance,
//           ...{
//             action: 'complete',
//             org: {
//               orgId: coid,
//               orgLevel: 'Facility'
//             }
//           }
//         }
//       ]);
//     case '/reports/patient':
//       return logTrackingEvent([
//         {
//           eventName: Events.Report.Patient_Reports_Compliance,
//           ...{
//             action: 'complete',
//             org: {
//               orgId: coid,
//               orgLevel: 'Facility'
//             }
//           }
//         }
//       ]);
//     case '/reports/patient/rounds':
//       return logTrackingEvent([
//         {
//           eventName: Events.Report.Patient_Reports_Rounds,
//           ...{
//             action: 'complete',
//             org: {
//               orgId: coid,
//               orgLevel: 'Facility'
//             }
//           }
//         }
//       ]);
//     case '/reports/patient/census':
//       return logTrackingEvent([
//         {
//           eventName: Events.Report.Patient_Reports_Census,
//           ...{
//             action: 'complete',
//             org: {
//               orgId: coid,
//               orgLevel: 'Facility'
//             }
//           }
//         }
//       ]);
//     default:
//       return undefined;
//   }
// };
